// extracted by mini-css-extract-plugin
module.exports = {"underline-link":"underline-static_underline-link__XmQWF"};